var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AddedTypeMenu"},[_c('DotMenuItem',{attrs:{"text":_vm.mixWB('DELETE_TYPE'),"itemID":"delete","color":"red"},on:{"dot-item-click":_vm.onDotItemClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }